// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://ad-drop-maps-api.shayelasolutions.co.za',
  // baseUrl: 'http://localhost:8008',
  webSocketUrl: 'wss://ws-ad-drop-maps.shayelasolutions.co.za',
  // webSocketUrl: 'ws://localhost:3000',
  apiUrl: 'https://api-liveness-module.shayelasolutions.co.za',

  facialDirection: 'https://api-facial-direction.shayelasolutions.co.za',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
